var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('assert'),
    assert = _require.strict;

var _require2 = require('util'),
    inspect = _require2.inspect;

var _require3 = require('os'),
    EOL = _require3.EOL;

var _require4 = require('../../help/runtime_support'),
    keyObjectSupported = _require4.keyObjectSupported;

var _require5 = require('../../help/key_object'),
    createPublicKey = _require5.createPublicKey;

var _require6 = require('../../help/key_utils'),
    keyObjectToJWK = _require6.keyObjectToJWK;

var _require7 = require('../../help/consts'),
    THUMBPRINT_MATERIAL = _require7.THUMBPRINT_MATERIAL,
    PUBLIC_MEMBERS = _require7.PUBLIC_MEMBERS,
    PRIVATE_MEMBERS = _require7.PRIVATE_MEMBERS,
    JWK_MEMBERS = _require7.JWK_MEMBERS,
    KEYOBJECT = _require7.KEYOBJECT,
    USES_MAPPING = _require7.USES_MAPPING,
    OPS = _require7.OPS,
    USES = _require7.USES;

var isObject = require('../../help/is_object');

var thumbprint = require('../thumbprint');

var errors = require('../../errors');

var privateApi = Symbol('privateApi');

var _require8 = require('../../registry'),
    JWK = _require8.JWK;

var Key =
/*#__PURE__*/
function () {
  "use strict";

  function Key(keyObject) {
    var _objectSpread2;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        alg = _ref.alg,
        use = _ref.use,
        kid = _ref.kid,
        ops = _ref.key_ops,
        x5c = _ref.x5c,
        x5t = _ref.x5t,
        x5t256 = _ref['x5t#S256'];

    _classCallCheck(this, Key);

    if (use !== undefined) {
      if (typeof use !== 'string' || !USES.has(use)) {
        throw new TypeError('`use` must be either "sig" or "enc" string when provided');
      }
    }

    if (alg !== undefined) {
      if (typeof alg !== 'string' || !alg) {
        throw new TypeError('`alg` must be a non-empty string when provided');
      }
    }

    if (kid !== undefined) {
      if (typeof kid !== 'string' || !kid) {
        throw new TypeError('`kid` must be a non-empty string when provided');
      }
    }

    if (ops !== undefined) {
      if (!Array.isArray(ops) || !ops.length || ops.some(function (o) {
        return typeof o !== 'string';
      })) {
        throw new TypeError('`key_ops` must be a non-empty array of strings when provided');
      }

      ops = Array.from(new Set(ops)).filter(function (x) {
        return OPS.has(x);
      });
    }

    if (ops && use) {
      if (use === 'enc' && ops.some(function (x) {
        return USES_MAPPING.sig.has(x);
      }) || use === 'sig' && ops.some(function (x) {
        return USES_MAPPING.enc.has(x);
      })) {
        throw new errors.JWKInvalid('inconsistent JWK "use" and "key_ops"');
      }
    }

    if (keyObjectSupported && x5c !== undefined) {
      if (!Array.isArray(x5c) || !x5c.length || x5c.some(function (c) {
        return typeof c !== 'string';
      })) {
        throw new TypeError('`x5c` must be an array of one or more PKIX certificates when provided');
      }

      x5c.forEach(function (cert, i) {
        var publicKey;

        try {
          publicKey = createPublicKey({
            key: "-----BEGIN CERTIFICATE-----".concat(EOL).concat((cert.match(/.{1,64}/g) || []).join(EOL)).concat(EOL, "-----END CERTIFICATE-----"),
            format: 'pem'
          });
        } catch (err) {
          throw new errors.JWKInvalid("`x5c` member at index ".concat(i, " is not a valid base64-encoded DER PKIX certificate"));
        }

        if (i === 0) {
          try {
            assert.deepEqual(publicKey.export({
              type: 'spki',
              format: 'der'
            }), (keyObject.type === 'public' ? keyObject : createPublicKey(keyObject)).export({
              type: 'spki',
              format: 'der'
            }));
          } catch (err) {
            throw new errors.JWKInvalid('The key in the first `x5c` certificate MUST match the public key represented by the JWK');
          }
        }
      });
    }

    Object.defineProperties(this, _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, KEYOBJECT, {
      value: isObject(keyObject) ? undefined : keyObject
    }), _defineProperty(_objectSpread2, "keyObject", {
      get: function get() {
        if (!keyObjectSupported) {
          throw new errors.JOSENotSupported('KeyObject class is not supported in your Node.js runtime version');
        }

        return this[KEYOBJECT];
      }
    }), _defineProperty(_objectSpread2, "type", {
      value: keyObject.type
    }), _defineProperty(_objectSpread2, "private", {
      value: keyObject.type === 'private'
    }), _defineProperty(_objectSpread2, "public", {
      value: keyObject.type === 'public'
    }), _defineProperty(_objectSpread2, "secret", {
      value: keyObject.type === 'secret'
    }), _defineProperty(_objectSpread2, "alg", {
      value: alg,
      enumerable: alg !== undefined
    }), _defineProperty(_objectSpread2, "use", {
      value: use,
      enumerable: use !== undefined
    }), _defineProperty(_objectSpread2, "x5c", _objectSpread({
      enumerable: x5c !== undefined
    }, x5c ? {
      get: function get() {
        return _toConsumableArray(x5c);
      }
    } : {
      value: undefined
    })), _defineProperty(_objectSpread2, "key_ops", _objectSpread({
      enumerable: ops !== undefined
    }, ops ? {
      get: function get() {
        return _toConsumableArray(ops);
      }
    } : {
      value: undefined
    })), _defineProperty(_objectSpread2, "kid", _objectSpread({
      enumerable: true
    }, kid ? {
      value: kid
    } : {
      get: function get() {
        Object.defineProperty(this, 'kid', {
          value: this.thumbprint,
          configurable: false
        });
        return this.kid;
      },
      configurable: true
    })), _objectSpread2), x5c ? {
      x5t: _objectSpread({
        enumerable: true
      }, x5t ? {
        value: x5t
      } : {
        get: function get() {
          Object.defineProperty(this, 'x5t', {
            value: thumbprint.x5t(this.x5c[0]),
            configurable: false
          });
          return this.x5t;
        },
        configurable: true
      })
    } : undefined, {}, x5c ? {
      'x5t#S256': _objectSpread({
        enumerable: true
      }, x5t256 ? {
        value: x5t256
      } : {
        get: function get() {
          Object.defineProperty(this, 'x5t#S256', {
            value: thumbprint['x5t#S256'](this.x5c[0]),
            configurable: false
          });
          return this['x5t#S256'];
        },
        configurable: true
      })
    } : undefined, {
      thumbprint: {
        get: function get() {
          Object.defineProperty(this, 'thumbprint', {
            value: thumbprint.kid(this[THUMBPRINT_MATERIAL]()),
            configurable: false
          });
          return this.thumbprint;
        },
        configurable: true
      }
    }));
  }

  _createClass(Key, [{
    key: "toPEM",
    value: function toPEM() {
      var priv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.secret) {
        throw new TypeError('symmetric keys cannot be exported as PEM');
      }

      if (priv && this.public === true) {
        throw new TypeError('public key cannot be exported as private');
      }

      var _encoding$type = encoding.type,
          type = _encoding$type === void 0 ? priv ? 'pkcs8' : 'spki' : _encoding$type,
          cipher = encoding.cipher,
          passphrase = encoding.passphrase;
      var keyObject = this[KEYOBJECT];

      if (!priv) {
        if (this.private) {
          keyObject = createPublicKey(keyObject);
        }

        if (cipher || passphrase) {
          throw new TypeError('cipher and passphrase can only be applied when exporting private keys');
        }
      }

      if (priv) {
        return keyObject.export({
          format: 'pem',
          type: type,
          cipher: cipher,
          passphrase: passphrase
        });
      }

      return keyObject.export({
        format: 'pem',
        type: type
      });
    }
  }, {
    key: "toJWK",
    value: function toJWK() {
      var _this = this;

      var priv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (priv && this.public === true) {
        throw new TypeError('public key cannot be exported as private');
      }

      var components = _toConsumableArray(this.constructor[priv ? PRIVATE_MEMBERS : PUBLIC_MEMBERS]).map(function (k) {
        return [k, _this[k]];
      });

      var result = {};
      Object.keys(components).forEach(function (key) {
        var _components$key = _slicedToArray(components[key], 2),
            k = _components$key[0],
            v = _components$key[1];

        result[k] = v;
      });
      result.kty = this.kty;
      result.kid = this.kid;

      if (this.alg) {
        result.alg = this.alg;
      }

      if (this.key_ops && this.key_ops.length) {
        result.key_ops = this.key_ops;
      }

      if (this.use) {
        result.use = this.use;
      }

      if (this.x5c) {
        result.x5c = this.x5c;
      }

      if (this.x5t) {
        result.x5t = this.x5t;
      }

      if (this['x5t#S256']) {
        result['x5t#S256'] = this['x5t#S256'];
      }

      return result;
    }
  }, {
    key: JWK_MEMBERS,
    value: function value() {
      var _this2 = this;

      var props = this[KEYOBJECT].type === 'private' ? this.constructor[PRIVATE_MEMBERS] : this.constructor[PUBLIC_MEMBERS];
      Object.defineProperties(this, _toConsumableArray(props).reduce(function (acc, component) {
        acc[component] = {
          get: function get() {
            var _this3 = this;

            var jwk = keyObjectToJWK(this[KEYOBJECT]);
            Object.defineProperties(this, Object.entries(jwk).filter(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 1),
                  key = _ref3[0];

              return props.has(key);
            }).reduce(function (acc, _ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  key = _ref5[0],
                  value = _ref5[1];

              acc[key] = {
                value: value,
                enumerable: _this3.constructor[PUBLIC_MEMBERS].has(key),
                configurable: false
              };
              return acc;
            }, {}));
            return this[component];
          },
          enumerable: _this2.constructor[PUBLIC_MEMBERS].has(component),
          configurable: true
        };
        return acc;
      }, {}));
    }
    /* c8 ignore next 8 */

  }, {
    key: inspect.custom,
    value: function value() {
      return "".concat(this.constructor.name, " ").concat(inspect(this.toJWK(false), {
        depth: Infinity,
        colors: process.stdout.isTTY,
        compact: false,
        sorted: true
      }));
    }
    /* c8 ignore next 3 */

  }, {
    key: THUMBPRINT_MATERIAL,
    value: function value() {
      throw new Error("\"[THUMBPRINT_MATERIAL]()\" is not implemented on ".concat(this.constructor.name));
    }
  }, {
    key: "algorithms",
    value: function algorithms(operation,
    /* the rest is private API */
    int, opts) {
      var _this4 = this;

      var _ref6 = int === privateApi ? opts : {},
          _ref6$use = _ref6.use,
          use = _ref6$use === void 0 ? this.use : _ref6$use,
          _ref6$alg = _ref6.alg,
          alg = _ref6$alg === void 0 ? this.alg : _ref6$alg,
          _ref6$key_ops = _ref6.key_ops,
          ops = _ref6$key_ops === void 0 ? this.key_ops : _ref6$key_ops;

      if (alg) {
        return new Set(this.algorithms(operation, privateApi, {
          alg: null,
          use: use,
          key_ops: ops
        }).has(alg) ? [alg] : undefined);
      }

      if (typeof operation === 'symbol') {
        try {
          return this[operation]();
        } catch (err) {
          return new Set();
        }
      }

      if (operation && ops && !ops.includes(operation)) {
        return new Set();
      }

      switch (operation) {
        case 'decrypt':
        case 'deriveKey':
        case 'encrypt':
        case 'sign':
        case 'unwrapKey':
        case 'verify':
        case 'wrapKey':
          return new Set(Object.entries(JWK[this.kty][operation]).map(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
                alg = _ref8[0],
                fn = _ref8[1];

            return fn(_this4) ? alg : undefined;
          }).filter(Boolean));

        case undefined:
          return new Set([].concat(_toConsumableArray(this.algorithms('sign')), _toConsumableArray(this.algorithms('verify')), _toConsumableArray(this.algorithms('decrypt')), _toConsumableArray(this.algorithms('encrypt')), _toConsumableArray(this.algorithms('unwrapKey')), _toConsumableArray(this.algorithms('wrapKey')), _toConsumableArray(this.algorithms('deriveKey'))));

        default:
          throw new TypeError('invalid key operation');
      }
    }
    /* c8 ignore next 3 */

  }], [{
    key: "generate",
    value: function generate() {
      return _regeneratorRuntime.async(function generate$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              throw new Error("\"static async generate()\" is not implemented on ".concat(this.name));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
    /* c8 ignore next 3 */

  }, {
    key: "generateSync",
    value: function generateSync() {
      throw new Error("\"static generateSync()\" is not implemented on ".concat(this.name));
    }
    /* c8 ignore next 3 */

  }, {
    key: PUBLIC_MEMBERS,
    get: function get() {
      throw new Error("\"static get [PUBLIC_MEMBERS]()\" is not implemented on ".concat(this.name));
    }
    /* c8 ignore next 3 */

  }, {
    key: PRIVATE_MEMBERS,
    get: function get() {
      throw new Error("\"static get [PRIVATE_MEMBERS]()\" is not implemented on ".concat(this.name));
    }
  }]);

  return Key;
}();

module.exports = Key;